import { apiCall } from './api.service';

export const getGroups = async (token, organisationId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/groups`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const getGroup = async (token, organisationId, groupId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/groups/${groupId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const createGroup = async (token, organisationId, groupData) => {
    const method = 'post';
    const path = `api/v1/organisations/${organisationId}/groups`;

    const response = await apiCall(method, groupData, path, token);
    return response;
};

export const updateGroup = async (token, organisationId, groupId, groupData) => {
    const method = 'put';
    const path = `api/v1/organisations/${organisationId}/groups/${groupId}`;

    const response = await apiCall(method, groupData, path, token);
    return response;
};

export const deleteGroup = async (token, organisationId, groupId) => {
    const method = 'delete';
    const path = `api/v1/organisations/${organisationId}/groups/${groupId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};
